/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

/* Components */
import Sidebar from '../Sidebar';
import Main from '../Main';

/* Utils */
import { SIDEBAR, MAIN } from '../../utils/focusKey';
import { useIsSidebarExpanded, useSetSidebarStateContext } from '../../providers/SidebarStateContext';

/* Other */
import { selectShowModal } from '../../storage/modal/selectors';

/* Styles */
import './LanderLayout.scss';

function LanderLayout({
  className,
  children,
  withPadding,
  pageId,
  initialScrollPosition,
}) {
  const isSidebarExpanded = useIsSidebarExpanded();
  const { openSidebar, closeSidebar } = useSetSidebarStateContext();
  const isModalShown = useSelector(selectShowModal) || false;

  return (
    <div className="dtv-html5-c-lander-layout">
      <Sidebar
        className="dtv-html5-c-lander-layout__sidebar"
        focusKey={SIDEBAR}
        open={openSidebar}
        close={closeSidebar}
        focusRestorable={isSidebarExpanded}
        expanded={isSidebarExpanded}
        isModalShown={isModalShown}
      />
      <Main
        className={`dtv-html5-c-lander-layout__main ${
          withPadding ? 'dtv-html5-c-lander-layout__main--with-padding' : ''
        } ${className}`}
        openSidebar={openSidebar}
        focusKey={MAIN}
        isSidebarExpanded={isSidebarExpanded}
        pageId={pageId}
        initialScrollPosition={initialScrollPosition}
        isModalShown={isModalShown}
      >
        {children}
      </Main>
    </div>
  );
}

LanderLayout.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  withPadding: PropTypes.bool,
  pageId: PropTypes.string,
  initialScrollPosition: PropTypes.number,
};

LanderLayout.defaultProps = {
  className: '',
  children: [],
  withPadding: false,
  pageId: undefined,
  initialScrollPosition: 0,
};

export default memo(LanderLayout);
